/** @format */

import {
  convertMinsToHours,
  getFromDate,
  getToDate,
  formatINRCurrency,
} from "../../Common/utils/statsUtil";

export const TOURNEY_FINISH_DISTRIBUTION_PROPS = {
  LATE_FINISHED: "lateFinished",
  MID_LATE: "midLate",
  MID_FINISHED: "midFinished",
  MID_EARLY: "midEarly",
  EARLY_FINISHED: "earlyFinished",
};

export const TOURNEY_FINISH_DISTRIBUTION_PROP_LBL_MAP = {
  [TOURNEY_FINISH_DISTRIBUTION_PROPS.LATE_FINISHED]: {
    label: "Late Finishes",
    clrCode: "var(--color-sanky-node1)",
    description: "",
  },
  [TOURNEY_FINISH_DISTRIBUTION_PROPS.MID_LATE]: {
    label: "Mid Late",
    clrCode: "var(--color-sanky-node2)",
    description: "",
  },
  [TOURNEY_FINISH_DISTRIBUTION_PROPS.MID_FINISHED]: {
    label: "Mid Finishes",
    clrCode: "var(--color-sanky-node3)",
    description: "",
  },
  [TOURNEY_FINISH_DISTRIBUTION_PROPS.MID_EARLY]: {
    label: "Mid Early",
    clrCode: "var(--color-sanky-node4)",
    description: "",
  },
  [TOURNEY_FINISH_DISTRIBUTION_PROPS.EARLY_FINISHED]: {
    label: "Early Finishes",
    clrCode: "var(--color-sanky-node5)",
    description: "",
  },
};

export const HUD_STATS_PROPS = {
  WSD: "wsd",
  WTSD: "wtsd",
  VPIP: "vpip",
  PFR: "pfr",
  THREE_BET: "threeBet",
  FOLD_TO_THREE_BET: "foldToThreeBet",
  C_BET: "cbet",
  FOLD_TO_C_BET: "foldToCBet",
  STEAL: "steal",
  CHECK_RAISE: "checkRaise",
};

export const HUD_STATS_PROP_LBL_CLR_MAP = {
  [HUD_STATS_PROPS.WSD]: {
    label: "WSD",
    clrCode: "var(--color-warning)",
    description: "",
  },
  [HUD_STATS_PROPS.WTSD]: {
    label: "WTSD",
    clrCode: "var(--color-info)",
    description: "",
  },
  [HUD_STATS_PROPS.VPIP]: {
    label: "VPIP",
    clrCode: "url(#gradientId-vpip)",
    description: "Voluntarily Put Money In Pot",
  },
  [HUD_STATS_PROPS.PFR]: {
    label: "PFR",
    clrCode: "url(#gradientId-pfr)",
    description: "Pre-Flop Raise",
  },
  [HUD_STATS_PROPS.THREE_BET]: {
    label: "3 Bet",
    clrCode: "#1892C3",
    description: "",
  },
  [HUD_STATS_PROPS.FOLD_TO_THREE_BET]: {
    label: "Fold to 3-Bet",
    clrCode: "#0272C7",
    description: "",
  },
  [HUD_STATS_PROPS.C_BET]: {
    label: "C-Bet",
    clrCode: "#30C0DA",
    description: "",
  },
  [HUD_STATS_PROPS.FOLD_TO_C_BET]: {
    label: "Fold to C-Bet",
    clrCode: "#3DB4B2",
    description: "",
  },
  [HUD_STATS_PROPS.STEAL]: {
    label: "Steal",
    clrCode: "var(--color-info)",
    description: "",
  },
  [HUD_STATS_PROPS.CHECK_RAISE]: {
    label: "Check/Raise",
    clrCode: "var(--color-info)",
    description: "",
  },
};

export const statsCashConfig = [
  {
    key: "biggestPotWin",
    label: "Biggest Pot Won",
    format: (val) => formatINRCurrency(val),
  },
  {
    key: "winRate",
    label: "Win Rate",
    format: (val) => `${val || 0} BB`,
  },
  {
    key: "totalCashBuyOut",
    label: "Total Cash Buyouts",
    format: (val) => formatINRCurrency(val),
  },
  {
    key: "playTime",
    label: "Total Time Played",
    format: (val) => convertMinsToHours(val),
  },
  {
    key: "largestSession",
    label: "Longest Session",
    format: (val) => convertMinsToHours(val),
  },
];

export const GAME_VARIANT_PROPS = {
  TEXAS_HOLDEM: "TEXAS_HOLDEM",
  OMAHA: "OMAHA",
  OMAHA5: "OMAHA5",
  OMAHA6: "OMAHA6",
};

export const GAME_VARIANT_LABEL_MAP = {
  [GAME_VARIANT_PROPS.TEXAS_HOLDEM]: {
    shortLabel: "NLH",
    longLabel: "Hold'em",
  },
  [GAME_VARIANT_PROPS.OMAHA]: {
    shortLabel: "PLO 4",
    longLabel: "Pot Limit Omaha 4",
  },
  [GAME_VARIANT_PROPS.OMAHA5]: {
    shortLabel: "PLO 5",
    longLabel: "Pot Limit Omaha 5",
  },
  [GAME_VARIANT_PROPS.OMAHA6]: {
    shortLabel: "PLO 6",
    longLabel: "Pot Limit Omaha 6",
  },
};
export const RADIAL_CHART_SEMI_CONFIG = {
  innerRadius: "100%",
  outerRadius: 50,
  barSize: 8,
  startAngle: 255,
  endAngle: -75,
};

export const RADIAL_CHART_FULL_CONFIG = {
  innerRadius: "130%",
  outerRadius: 70,
  barSize: 4,
  startAngle: 90,
  endAngle: -270,
};

export const gradient1 = ["#EABF69", "#D32C2C"];
export const gradient2 = ["#68CB66", "#EABF69", "#D32C2C"];
export const gradient3 = ["#68CB66", "#68CB66", "#EABF69"];
export const betFillColor1 = "#1892C3";
export const betFillColor2 = "#0272C7";
export const betFillColor3 = "#30C0DA";
export const betFillColor4 = "#3DB4B2";

export const linkGradientConfigA23 = [
  {
    offset: "28.73%",
    stopColor: "#042A33",
  },
  {
    offset: "125.03%",
    stopColor: "#F2F2F2",
  },
];

export const linkGradientConfigA52 = [
  {
    offset: "28.73%",
    stopColor: "#F2F2F2",
  },
  {
    offset: "125.03%",
    stopColor: "#042A33",
  },
];

export const STATS_CORNER_TABS = [
  {
    name: "Cash Games",
    gameType: "CASH",
    urlAppend: "cash",
  },
  {
    name: "Tournaments",
    gameType: "TOURNAMENTS",
    urlAppend: "tourney",
  },
];

export const GAME_VARIANT_TABS = [
  {
    label: "NLH",
    id: GAME_VARIANT_PROPS.TEXAS_HOLDEM,
  },
  {
    label: "PLO 4",
    id: GAME_VARIANT_PROPS.OMAHA,
  },
  {
    label: "PLO 5",
    id: GAME_VARIANT_PROPS.OMAHA5,
  },
  {
    label: "PLO 6",
    id: GAME_VARIANT_PROPS.OMAHA6,
  },
];

export const DURATION_DROPDOWN_ITEMS = [
  {
    label: "Last 7 Days",
    id: "last_7_days",
    dateRangeType: "LAST_7_DAYS",
    from: () => getFromDate(7),
    to: () => getToDate(),
  },
  {
    label: "Last 15 Days",
    id: "last_15_days",
    dateRangeType: "LAST_15_DAYS",
    from: () => getFromDate(15),
    to: () => getToDate(),
  },
  {
    label: "Last 30 Days",
    id: "last_30_days",
    dateRangeType: "LAST_30_DAYS",
    from: () => getFromDate(30),
    to: () => getToDate(),
  },
  {
    label: "Last 60 Days",
    id: "last_60_days",
    dateRangeType: "LAST_60_DAYS",
    from: () => getFromDate(60),
    to: () => getToDate(),
  },
  {
    label: "Lifetime",
    id: "lifetime",
    dateRangeType: "LIFETIME",
    from: () => 0,
    to: () => 0,
  },
];

export const tournamentPerformanceConfig = [
  {
    key: "tournamentsPlayed",
    label: "Tourneys Played",
  },
  {
    key: "totalCashes",
    label: "Total Cashes",
    format: (val) => formatINRCurrency(val),
    valueClass: "text-gold-primary",
  },
  {
    key: "tourneyWonPercent",
    label: "Tourneys Won",
    format: (val, data) => `${val || 0} % (${data["tourneyWon"] || 0})`,
  },
  {
    key: "itmPercent",
    label: "ITM",
    format: (val, data) => `${val || 0} % (${data["itmCount"] || 0})`,
  },
  {
    key: "finalTablePercent",
    label: "Final Table",
    format: (val, data) => `${val} % (${data["finalTableCount"]})`,
  },
  {
    key: "roi",
    label: "ROI",
    format: (val) => `${val} %`,
    show: (val) => val >= 0,
  },
  {
    key: "avgBuyIn",
    label: "Avg Buyin",
    format: (val) => formatINRCurrency(val),
  },
  {
    key: "avgEntries",
    label: "Avg Entrants",
  },
  {
    key: "hourlyWinRate",
    label: "Hourly Win Rate",
  },
  {
    key: "totalPlayTime",
    label: "Total Time Played",
    format: (val) => convertMinsToHours(val),
  },
];

export const RANK_DISPLAY_MAP = {
  1: "A", // Ace
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "J", // Jack
  12: "Q", // Queen
  13: "K", // King
};

export const abbreviationsList = [
  {
    abbreviation: "VPIP",
    fullForm: "Voluntarily Put Money in Pot",
    description:
      "The percentage of hands in which the player voluntarily puts money into the pot pre-flop (e.g., by limping, raising, or calling a raise), excluding forced bets like blinds.",
  },
  {
    abbreviation: "PFR",
    fullForm: "Pre-Flop Raise",
    description:
      "The percentage of hands in which the player makes a pre-flop raise (either an open raise or a 3-bet+).",
  },
  {
    abbreviation: "WTSD",
    fullForm: "Went to Showdown",
    description:
      "The percentage of times the player won the pot when they went to showdown.",
  },
  {
    abbreviation: "WSD",
    fullForm: "Won Money at Showdown",
    description:
      "The percentage of hands where the player voluntarily put money into the pot and then proceeded to showdown.",
  },
  {
    abbreviation: "3-bet",
    fullForm: "3-bet",
    description:
      "The percentage of times the player makes a re-raise (the third bet in a sequence) pre-flop after an open raise.",
  },
  {
    abbreviation: "Fold to 3-bet",
    fullForm: "Fold to 3-bet",
    description:
      "The percentage of times the player folds to a 3-bet after opening with a raise.",
  },

  {
    abbreviation: "C-bet",
    fullForm: "Continuation Bet",
    description:
      "The percentage of times the player makes a bet on the flop after being the pre-flop raiser.",
  },
  {
    abbreviation: "Fold to C-bet",
    fullForm: "Fold to Continuation Bet",
    description:
      "The percentage of times the player folds to a continuation bet on the flop after being the pre-flop caller.",
  },
  {
    abbreviation: "Steal",
    fullForm: "Attempted Steal",
    description:
      "The percentage of hands where the player attempts to steal the blinds (by raising from the Cut-Off, Button, or Small Blind when no one has entered the pot before them).",
  },
  {
    abbreviation: "Check Raise",
    fullForm: "Check Raise",
    description:
      "The percentage of times the player checks and then raises a bet on a post-flop street.",
  },

  {
    abbreviation: "Biggest Pot Won",
    fullForm: "Biggest Pot Won",
    description:
      "Biggest pot amount won by the user on a cash game table(post rake).",
  },
  {
    abbreviation: "Total Buyouts",
    fullForm: "Total Cash Buyouts",
    description:
      "The cumulative sum of all money the user has brought out of the cash game tables over their lifetime. This refers to the total amount paid from the table into their balance.",
  },
  {
    abbreviation: "Largest Session",
    fullForm: "Largest Session",
    description: "Longest session duration of the user",
  },
  {
    abbreviation: "Total Cashes",
    fullForm: "Total Tourney Cashes",
    description:
      "The total amount won by the user in lifetime in all tournaments.",
  },
  {
    abbreviation: "Tourneys Played",
    fullForm: "Total Tourneys Played",
    description:
      "The total number of tournaments the user has registered for and played.",
  },
  {
    abbreviation: "Tourneys Won Percentage",
    fullForm: "Tournament Win Percentage",
    description:
      "The percentage of tournaments played that the user won (finished in 1st place). For same prize to top X positions, every user on those X positions is counted as position 1 for that particular tournament.",
  },
  {
    abbreviation: "ITM Percentage",
    fullForm: "In The Money Percentage",
    description:
      " The percentage of tournaments played where the user finished in a prize-winning position. If user won a ticket through a satellite only tourney, it goes into item no. 3. ",
  },
  {
    abbreviation: "Final Table Percentage",
    fullForm: "Final Table Percentage",
    description:
      "The percentage of tournaments played where the user reached the final table (typically the last 9 or 10 players, depending on tournament structure).",
  },

  {
    abbreviation: "ROI Percentage",
    fullForm: "Return on Investment Percentage",
    description:
      "Profitability metric for tournaments, showing the percentage return on the total money invested in tournament buy-ins.",
  },
  {
    abbreviation: "Avg Buyin",
    fullForm: "Average Buy-in",
    description:
      "The average cost of a tournament entry for all tournaments played by the user.",
  },
  {
    abbreviation: "Avg Entrants",
    fullForm: "Average Entrants",
    description:
      "The average number of players in the tournaments the user has played.",
  },
  {
    abbreviation: "Hourly Win Rate",
    fullForm: "Hourly Win Rate (Tournament)",
    description:
      "The user's average profit or loss per hour spent playing tournaments.",
  },
  {
    abbreviation: "Hours Played",
    fullForm: "Total Hours Played",
    description:
      "The cumulative total time (in hours and minutes) the user has spent actively playing hands at tables (only real money cash games). If user is playing two simultaneous tables for one hour, it counts as two hours of total gameplay time.",
  },
  {
    abbreviation: "Late Finishes",
    fullForm: "Late Finishes",
    description:
      "Reaching final stages(user finishing in top10% of total entries of the tournament)",
  },

  {
    abbreviation: "Mid/Late Finishes",
    fullForm: "Mid/Late Finishes",
    description:
      "Finishing just outside the final table, or in the latter half of the cashes.(10%, 30%)",
  },
  {
    abbreviation: "Mid Finishes",
    fullForm: "Mid Finishes",
    description: "Finishing in the middle of the field.(30%, 60%)",
  },
  {
    abbreviation: "Mid/Early Finishes",
    fullForm: "Mid/Early Finishes",
    description: "Finishing relatively early, but not immediately.(60%, 90%)",
  },
  {
    abbreviation: "Early Finishes",
    fullForm: "Early Finishes",
    description: "Busting out very early in the tournament.(>90%)",
  },
];

export const STATS_CORNER_MESSAGE = `Performance • Tight , aggressive, solid strategy`;

export const COLOR_GREEN = '#68CB66';
export const COLOR_YELLOW = '#EABF69';
export const COLOR_RED = '#D32C2C';
export const COLOR_BG = 'rgba(128, 166, 175, 0.1)';
